(function () {
  "use strict";

  CourseTraineesCtrl.$inject = ['$scope', '$rootScope', '$timeout', 'courseTraineesResource', 'resolveData', '$route', 'gridFormatters', 'mtypes', '$window', 'gridUtils', 'userGridUtils', 'courseSearch', 'trackingService', '$location', '$filter', 'compositeSearchData', 'notificationService', 'trainerPrivilege'];
  angular
    .module('trainerWebApp.course')
    .controller('CourseTraineesCtrl', CourseTraineesCtrl);

  function CourseTraineesCtrl($scope, $rootScope, $timeout, courseTraineesResource, resolveData, $route, gridFormatters, mtypes, $window,
                              gridUtils, userGridUtils, courseSearch, trackingService, $location, $filter, compositeSearchData,
                              notificationService, trainerPrivilege) {

    var courseId = $scope.courseId = $route.current.params.courseId;
    $window.document.title = "Course | Mindflash Training Management System";

    $scope.userRole = trainerPrivilege.roles();

    if (!resolveData) return;
    $scope.resolvedData = resolveData;
    var courseGroups = resolveData.groups;
    var courseStatus = resolveData.courseStatus.status;

    var isDraft = $scope.resolvedData.courseStatus.status == mtypes.courseStatus.draft;
    $scope.isArchived = $scope.resolvedData.courseStatus.status == mtypes.courseStatus.archive;

    var trainees = $scope.isArchived ? [] : mapTrainees($scope.resolvedData.trainees);

    function mapTrainees(trainees) {
      return _.map(trainees, function (trainee) {
        trainee.name = trainee.lastName + ', ' + trainee.firstName;
        trainee.courseStatus = courseStatus;
        return trainee;
      });
    }

    mapCourseStateSearchStrings();

    $scope.coursesAlteredWhileActive = $scope.resolvedData.coursesAlteredWhileActive;
    $scope.hasDeadline = $scope.resolvedData.courseSettings.hasDeadline;
    $scope.isLiveCourse = $scope.resolvedData.courseSettings.courseType == mtypes.courseType.live;
    $scope.showBulkDeadlineButton = $scope.hasDeadline && $scope.userRole.canExtendTraineeDeadlines;
    $scope.resolvedData = null;
    $scope.traineeCount = trainees.length;
    $scope.traineesToDrop = 0;
    $scope.overridePlaceholder = 'Search by name, email or group';


    var includeSelectCheckbox = $scope.userRole.canDropTrainees ||
      (!$scope.isLiveCourse && ($scope.userRole.canExtendTraineeDeadlines || $scope.userRole.canRemindTrainees || $scope.userRole.canResetTrainees)) ||
      ($scope.isLiveCourse && $scope.userRole.canMarkTraineeCompleted);

    $rootScope.page = {name: 'trainees', title: "Course Trainees"};

    var gridCommands = $scope.gridCommands = {};

    var columns = [
      {
        id: "name",
        name: "Name",
        field: "name",
        width: 300,
        cssClass: "cell-title",
        headerCssClass: "header-column-first",
        formatter: gridFormatters.traineeNameFormatter,
        sortable: true
      },
      {
        id: "email",
        name: "Email",
        field: "email",
        width: 300,
        headerCssClass: "header-column",
        formatter: gridFormatters.traineeEmailFormatter,
        sortable: true
      },
      {
        id: "invited",
        name: isDraft ? "Added" : "Invited",
        field: "invited",
        width: 126,
        headerCssClass: "header-column",
        formatter: gridFormatters.inviteFormatter,
        sortable: true
      },
      {
        id: "required",
        name: "Required",
        width: 84,
        field: "required",
        formatter: gridFormatters.courseRequiredFormatter,
        sortable: true
      }
    ];

    var statusColumn = {
      id: "status",
      name: "Status",
      field: "status",
      width: 120,
      headerCssClass: "header-column",
      formatter: gridFormatters.traineeCourseStatusFormatter,
      sortable: true,
      sorter: statusSorter
    };

    var someTraineesHasDeadline = _.some(trainees, function (t) {
      return t.completionDeadline;
    });

    if ($scope.hasDeadline || someTraineesHasDeadline) {
      columns.splice(2, 0, {
        id: "completionDeadline",
        name: "Deadline",
        field: "completionDeadline",
        minWidth: 200,
        headerCssClass: "header-column",
        formatter: gridFormatters.deadlineFormatter,
        sortable: true,
        hasDeadline: $scope.hasDeadline
      });
    }

    if ($scope.isUsernameEnabled) {
      columns.splice(2, 0, {
        id: "username",
        name: "Username",
        field: "username",
        minWidth: 80,
        headerCssClass: "header-column",
        sortable: true
      });
      if (!isDraft) {
        columns.splice(3, 0, statusColumn);
      }
    }
    else if (!isDraft) {
      columns.splice(2, 0, statusColumn);
    }

    function setupSearch() {
      $scope.searchSettings = courseSearch.createSearchSettings({
        filterHasResults: filterHasResults,
        gaPageName: trackingService.pages.courseTrainees.name,
        groups: courseGroups,
        setFilter: setSearchFilter
      });
    }

    setupSearch();

    var searchFilter = null;

    function filterHasResults(searchFilter) {
      return _.some($scope.getVisibleGridItems(), function (u) {
        return filterer(u, $scope.filterData) && searchFilter(u);
      });
    }

    function setSearchFilter(filter) {
      searchFilter = filter;
      updateFilter();
    }

    $scope.gridInfo = {
      options: {
        editable: false,
        enableCellNavigation: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        forceSyncScrolling: trainees.length < 500,
        multiColumnSort: true
      },
      columns: columns,
      onRowsChanged: onRowsChanged,
      onRowCountChanged: onRowCountChanged,
      onSelectedRowsChanged: onSelectedRowsChanged,
      onClick: onRowClick,
      filterFn: filterer,
      data: [],
      includeSelectCheckbox: includeSelectCheckbox,
      onEqualSort: onEqualSort
    };

    $scope.gridData = trainees.sort(sort);

    $scope.filteredTraineeCount = $scope.gridData.length;

    $scope.selectedRowsCount = 0;
    refreshSelectedTraineesText();

    function statusSorter(a, b) {
      return userGridUtils.sort.byCourseStatus(a, b);
    }

    var completedSearchString = "complete completed finish finished";
    var passedSearchString = "pass passed";
    var failedSearchString = "fail failed";

    function courseStatusFound(item, searchCriteria) {
      if (!item.courseStateSearchString)
        return;
      var itemFound = item.courseStateSearchString.toLowerCase().indexOf(searchCriteria.toLowerCase()) >= 0;
      if (!itemFound) return false;
      if (item.status == mtypes.courseStateStatus.completed) {
        if (completedSearchString.toLowerCase().indexOf(searchCriteria.toLowerCase()) >= 0) {
          return true;
        }
        if (item.passed) {
          return passedSearchString.toLowerCase().indexOf(searchCriteria.toLowerCase()) >= 0;
        }
        else {
          return failedSearchString.toLowerCase().indexOf(searchCriteria.toLowerCase()) >= 0;
        }
      }
      return true;
    }

    function filterer(itemToFilter, args) {
      if (!args) return true;
      if (!args.courseStateCriteria && !args.searchFilter)
        return true;

      var item = itemToFilter._parent || itemToFilter;

      if (args.searchFilter && !args.searchFilter(item)) return false;

      if (args.courseStateCriteria === 'all') return true;

      if (item.status === mtypes.courseStateStatus.invited)
        return args.courseStateCriteria === 'invited';
      if (item.status === mtypes.courseStateStatus.started)
        return args.courseStateCriteria === 'progress';
      if (item.status === mtypes.courseStateStatus.completed) {
        if (args.courseGradeCriteria === 'all')
          return args.courseStateCriteria === 'completed';
        if (item.passed)
          return args.courseStateCriteria === 'completed' && args.courseGradeCriteria === 'passed';
        else
          return args.courseStateCriteria === 'completed' && args.courseGradeCriteria === 'failed';
      }
      if (item.status === mtypes.courseStateStatus.missedCompletionDeadline)
        return args.courseStateCriteria === 'missed';
      return false;
    }

    $scope.courseStateCriteria = $location.search()['f'] ? $location.search()['f'] : 'all';
    $scope.courseGradeCriteria = $location.search()['gf'] ? $location.search()['gf'] : 'all';
    $scope.showGradeCriteria = true;

    $scope.$watch('courseStateCriteria', function (item) {
      if (!item) return;
      updateFilter();
    });

    $scope.$watch('courseGradeCriteria', function (item) {
      if (!item) return;
      updateFilter();
    });


    var viewData = [];

    function onRowCountChanged(args, items) {
      //filter out expanded courses
      viewData = items;
      $scope.filteredTraineeCount = viewData.length;
      updateTraineesToReinvite();
      updateTraineesToComplete();
      updateTraineesToRemind();
      updateTraineesToDrop();
    }

    function onRowsChanged(args, items) {
      viewData = _.filter(items, function (item) {
        return !item._parent;
      });
      updateTraineesToReinvite();
      updateTraineesToComplete();
      updateTraineesToRemind();
      updateTraineesToDrop();
    }

    function onRowClick(item, targetClasses, target) {
      if (targetClasses.indexOf('action-reinvite') !== -1) {
        if (!item.canBeReinvited) return;
        return requestReset(item);
      }
      if (targetClasses.indexOf('action-remind') !== -1) {
        if (!item.pokeRemindEnabled) return;
        return doRemind(item);
      }
      if (targetClasses.indexOf('action-complete') !== -1) {
        if (!item.canBeCompleted) return;

        // Pop-up to set the score if course has quizzes. Don't actually call the endpoint to complete the course.
        // This way if they hit cancel on the input score dialog the course isn't completed.
        if (resolveData.courseHasQuizzes)
          return setScore(item);

        return doComplete(item);
      }
      if (targetClasses.indexOf('action-delete') !== -1) {
        if (!item.canBeDropped) return;
        return showDropConfirmation(item);
      }
      if (targetClasses.indexOf('action-required') !== -1) {
        return makeRequired(item);
      }

      if (targetClasses.indexOf('action-setDeadline') !== -1 ||
        targetClasses.indexOf('action-extendDeadline') !== -1) {
        return gridUtils.showDatePicker(target, item, onDeadlineChanged);
      }
      if (targetClasses.indexOf('action-manageUser') !== -1) {
        return goToSeries(item);
      }
      if (targetClasses.indexOf('action-set-score') !== -1) {
        return setScore(item);
      }
    }

    function goToSeries(item) {
      notificationService.setNotification({
        message: 'You just came from ' + $scope.title.courseTitle + ' course',
        pageToShow: 'Series',
        close: true,
        displayOrder: 1,
        btn: 'Back',
        btnUrl: $location.path()
      });
      compositeSearchData.setSearchData('user', item.id);
      $location.path('/TMS/Series/' + item.seriesId + '/trainees');

    };

    function makeRequired(item, cb) {
      if (item.traineeIsInCourseInSeries)
        return;
      if (~[mtypes.courseStateStatus.completed, mtypes.courseStateStatus.missedCompletionDeadline].indexOf(item.status))
        return;

      // convert to boolean because it is a boolean
      var required = item.required == 1;
      item.required = !required;

      courseTraineesResource.updateTraineeRequiredInCourse($scope.courseId, [item.id], item.required, function (result) {
        gridCommands.updateRow(item);
        (cb || angular.noop)();
      }, function (error) {
        (cb || angular.noop)();
      });
    }

    function doRemind(trainees, cb) {
      var bulkAction = true;
      if (!angular.isArray(trainees)) {
        bulkAction = false;
        trainees = [trainees];
      }

      var ids = _.pluck(trainees, 'id');
      courseTraineesResource.pokeRemindCourseTrainees($scope.courseId, ids, function (result) {
        refreshData();
        if (bulkAction)
          gridCommands.cleanSelection();
        (cb || angular.noop)();
      }, function (error) {
        gridCommands.cleanSelection();
        (cb || angular.noop)();
      });
    }

    // Bulk complete events
    $scope.requestBulkComplete = function () {
      $scope.$broadcast('courseBulkCompleteRequested', $scope.traineesToCompleteCnt);
    };
    $scope.$on('courseBulkCompleteConfirmed', function (event, notUsed, cb) {
      event.stopPropagation();
      doComplete(traineesToComplete, cb);
    });

    function doComplete(trainees, cb) {
      var bulkAction = true;
      if(!angular.isArray(trainees)) {
        bulkAction = false;
        trainees = [trainees];
      }

      var ids =_.pluck(trainees, 'id');
      courseTraineesResource.completeCourseTrainees($scope.courseId, ids, function (result) {
        refreshData();
        if (bulkAction)
          gridCommands.cleanSelection();
        (cb || angular.noop)();
      }, function (error) {
        gridCommands.cleanSelection();
        (cb || angular.noop)();
      });
    }

    function setScore(trainee, cb) {
      var scoreText = prompt('Enter trainee\'s score');

      if (scoreText != null) {
        var score = parseInt(scoreText);
        if (!isNaN(score) && score >= 0 && score <= 100) {
          courseTraineesResource.setTraineeScore($scope.courseId, trainee.id, score, function (result) {
            refreshData();
            (cb || angular.noop)();
          }, function (error) {
            gridCommands.cleanSelection();
            (cb || angular.noop)();
          });
        }
      }
    }

    function doDrop(trainees, cb) {
      var bulkAction = true;
      if (!angular.isArray(trainees)) {
        bulkAction = false;
        trainees = [trainees];
      }

      var ids = _.pluck(trainees, 'id');
      courseTraineesResource.uninviteCourseTrainees($scope.courseId, ids, function (result) {
        refreshData();
        if (bulkAction)
          gridCommands.cleanSelection();
        (cb || angular.noop)();
      }, function (error) {
        gridCommands.cleanSelection();
        (cb || angular.noop)();
      });
    }

    function refreshData() {
      courseTraineesResource.traineesSetup(courseId, function (result) {
        $scope.gridData = trainees = mapTrainees(restoreSortIn(result.trainees));
        $scope.traineeCount = trainees.length;
        viewData = trainees;
        updateTraineesToRemind();
        updateTraineesToDrop();
        updateTraineesToReinvite();
        updateTraineesToComplete();
        mapCourseStateSearchStrings();
        updateTraineesToUpdateDeadline();
      });
    }

    $scope.$watch('traineeSearchCriteria', updateFilter);

    function updateFilter() {
      if ($scope.courseStateCriteria !== "completed") $scope.courseGradeCriteria = "all";
      $scope.filterData = {
        searchFilter: searchFilter,
        courseGradeCriteria: $scope.courseGradeCriteria,
        courseStateCriteria: $scope.courseStateCriteria
      };
      $scope.showGradeCriteria = $scope.courseStateCriteria === 'completed';
    }

    function showDropConfirmation(item) {
      $scope.$broadcast('uninviteTraineeEvent', item);
    }

    $scope.searchChanged = updateFilter;


    // Reset events
    function requestReset(item) {
      $scope.$broadcast('courseResetRequested', item);
    }

    $scope.$on('courseResetConfirmed', function (event, trainee, cb) {
      event.stopPropagation();
      doReset([trainee], cb);
    });

    // Bulk reset events
    $scope.requestBulkReset = function () {
      $scope.$broadcast('courseBulkResetRequested', $scope.traineesToReinviteCnt);
    };
    $scope.$on('courseBulkResetConfirmed', function (event, notUsed, cb) {
      event.stopPropagation();
      doReset(traineesToReinvite, cb);
    });

    function doReset(trainees, cb) {
      var bulkAction = true;
      if (!angular.isArray(trainees)) {
        bulkAction = false;
        trainees = [trainees];
      }

      var ids = _.pluck(trainees, 'id');
      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

      courseTraineesResource.retakeCourse($scope.courseId, ids, dateString, function () {
        refreshData();
        if (bulkAction)
          gridCommands.cleanSelection();
        (cb || angular.noop)();
      }, function (error) {
        gridCommands.cleanSelection();
        (cb || angular.noop)();
      });
    }


    $scope.$on('uninviteTraineesConfirmEvent', function (event, trainee, cb) {
      event.stopPropagation();
      doDrop(_.isEmpty(trainee) ? traineesToDrop : trainee, cb);
    });

    $scope.$on('remindTraineesConfirmEvent', function (event, trainee, cb) {
      event.stopPropagation();
      doRemind(_.isEmpty(trainee) ? traineesToRemind : trainee, cb);
    });

    $scope.$on('setDeadlineTraineesConfirmEvent', function (event, notUsed, cb) {
      event.stopPropagation();
      doSetDeadline(traineesToSetDeadline, $scope.bulkDeadlineDate, cb);
      var notification = {
        message: 'Deadline updated for ' + $scope.traineesToSetDeadlineCnt + ' trainee(s).',
        pageToShow: 'Course',
        close: true,
        displayOrder: 2
      }
      notificationService.setNotification(notification);
      $timeout(function () {
        notificationService.removeNotification(notification);
      }, 5000);
    });

    $scope.getTraineesCount = function () {
      return ' (' + ($scope.traineesToDrop || 0) + ')';
    };

    function doSetDeadline(trainees, deadline, cb) {
      var bulkAction = true;
      if (!angular.isArray(trainees)) {
        bulkAction = false;
        trainees = [trainees];
      }

      var ids = _.pluck(trainees, 'id');
      courseTraineesResource.updateDeadline($scope.courseId, ids, deadline, function (result) {
        refreshData();
        if (bulkAction)
          gridCommands.cleanSelection();
        (cb || angular.noop)();
      }, function (error) {
        (cb || angular.noop)();
      });
    }

    function sort(a, b) {
      if (!(typeof gridCommands.sort === 'function'))
        return userGridUtils.sort.byPersonName(a, b);

      currentSortColumn = gridCommands.sort();
      if (!currentSortColumn)
        return userGridUtils.sort.byPersonName(a, b);

      var column = currentSortColumn.columnId.toString();
      if (column == 'name') {
        userGridUtils.sort.byPersonName(a, b);
      } else if (a[column] == b[column]) {
        return sortBy(a.email, b.email);
      } else {
        var value1 = isNaN(a[column]) ? a[column].toLowerCase() : a[column];
        var value2 = isNaN(b[column]) ? b[column].toLowerCase() : b[column];
        return sortBy(value1, value2);
      }
    }

    function sortBy(a, b) {
      var sign = currentSortColumn ? currentSortColumn.sortAsc ? 1 : -1 : 1;
      return ((a < b) ? -1 : ((a > b) ? 1 : 0)) * sign;
    }

    $scope.$on('$destroy', function () {
      // cleanup
    });

    $scope.getAddTraineesUrl = function () {
      return '#/TMS/Distribute_Course/' + $scope.courseId + '/addExistingTrainees';
    };

    $scope.getAddTraineesFromYammerUrl = function () {
      return '#/TMS/Distribute_Course/' + $scope.courseId + '/addYammerUsers';
    };

    $scope.requestDrop = function () {
      $scope.$broadcast('traineesToDropEvent', $scope.traineesToDropCnt);
    }

    $scope.requestRemind = function () {
      $scope.$broadcast('traineesToRemindEvent', $scope.traineesToRemindCnt);
    }

    var traineesToReinvite = [];
    var traineesToComplete = [];
    var traineesToDrop = [];
    var traineesToRemind = [];
    var traineesToSetDeadline = [];

    function updateTraineesToReinvite() {
      traineesToReinvite = [];
      _.each(viewData, function (trainee) {
        if (~selectedIds.indexOf(trainee.id) && trainee.canBeReinvited) {
          traineesToReinvite.push(trainee);
        }
      });
      $scope.traineesToReinviteCnt = traineesToReinvite.length;
    }

    function updateTraineesToComplete() {
      traineesToComplete = [];
      _.each(viewData, function (trainee) {
        if (~selectedIds.indexOf(trainee.id) && trainee.canBeCompleted && !trainee.traineeIsInCourseInSeries) {
          traineesToComplete.push(trainee);
        }
      });
      $scope.traineesToCompleteCnt = traineesToComplete.length;
    }

    function updateTraineesToDrop() {
      traineesToDrop = [];
      _.each(viewData, function (trainee) {
        if (trainee.canBeDropped && selectedIds.indexOf(trainee.id) != -1) {
          traineesToDrop.push(trainee);
        }
      });
      $scope.traineesToDropCnt = traineesToDrop.length;
    }

    function updateTraineesToRemind() {
      traineesToRemind = [];
      _.each(viewData, function (trainee) {
        if (trainee.pokeRemindEnabled && trainee.status != mtypes.courseStateStatus.completed && selectedIds.indexOf(trainee.id) != -1) {
          traineesToRemind.push(trainee);
        }
      });
      $scope.traineesToRemindCnt = traineesToRemind.length;
    }

    function updateTraineesToUpdateDeadline() {
      $scope.bulkSetDeadlineEnabled = false;
      traineesToSetDeadline = [];

      if ($scope.courseStateCriteria == 'completed') return;

      _.each(viewData, function (trainee) {
        if (trainee.status != mtypes.courseStateStatus.completed && !trainee.traineeIsInCourseInSeries && ~selectedIds.indexOf(trainee.id)) {
          $scope.bulkSetDeadlineEnabled = true;
          traineesToSetDeadline.push(trainee);
        }
      });
      $scope.traineesToSetDeadlineCnt = traineesToSetDeadline.length;
    }

    $scope.getBackUrl = function () {
      return $scope.seriesId ? "#/TMS/Series/" + $scope.seriesId : "#/TMS/Distribute_Course/" + $scope.courseId;
    };

    var selectedIds = [];

    function onSelectedRowsChanged(args, value) {
      selectedIds = value;
      $scope.selectedRowsCount = selectedIds.length;
      refreshSelectedTraineesText();
      updateTraineesToReinvite();
      updateTraineesToComplete();
      updateTraineesToDrop();
      updateTraineesToRemind();
      updateTraineesToUpdateDeadline();
    }

    function refreshSelectedTraineesText() {
      $scope.selectedTraineesText = $scope.selectedRowsCount == 1 ? $scope.selectedRowsCount + ' Trainee selected' : $scope.selectedRowsCount + ' Trainees selected';
    }

    $scope.bulkReinviteText;
    $scope.$watch('traineesToReinviteCnt', function (value) {
      $scope.bulkReinviteText = 'Reset';
      if (value > 0) {
        $scope.bulkReinviteText += ' (' + value + ')';
      }
    });
    $scope.bulkCompleteText;
    $scope.$watch('traineesToCompleteCnt', function (value) {
      $scope.bulkCompleteText = 'Complete';
      if (value > 0) {
        $scope.bulkCompleteText += ' (' + value + ')';
      }
    });
    $scope.bulkDropText;
    $scope.$watch('traineesToDropCnt', function (value) {
      $scope.bulkDropText = 'Drop';
      if (value > 0) {
        $scope.bulkDropText += ' (' + value + ')';
      }
    });
    $scope.bulkRemindText;
    $scope.$watch('traineesToRemindCnt', function (value) {
      $scope.bulkRemindText = 'Remind';
      if (value > 0) {
        $scope.bulkRemindText += ' (' + value + ')';
      }
    });
    $scope.bulkDeadlineText;
    $scope.$watch('traineesToSetDeadlineCnt', function (value) {
      $scope.bulkDeadlineText = 'Set Deadline';
      if (value > 0)
        $scope.bulkDeadlineText += ' (' + value + ')';
    });

    function mapCourseStateSearchStrings() {
      _.each(trainees, function (trainee) {
        switch (trainee.status) {
          case mtypes.courseStateStatus.invited:
            trainee.courseStateSearchString = "invited invite not started";
            break;
          case mtypes.courseStateStatus.completed:
            trainee.courseStateSearchString = "complete completed finished pass passed fail failed";
            break;
          case mtypes.courseStateStatus.missedCompletionDeadline:
            trainee.courseStateSearchString = "missed completion deadline";
            break;
          case mtypes.courseStateStatus.started:
            trainee.courseStateSearchString = "started inprogress in progress";
            break;
        }
      });
    }

    var currentSortColumn;

    function restoreSortIn(data) {
      return data.sort(sort);
    }

    function onEqualSort(a, b) {
      return sort(a, b);
    }

    function onDeadlineChanged(date, item) {
      date = new Date(date);
      gridCommands.updateRow(item);
      courseTraineesResource.updateDeadline($scope.courseId, [item.id], $filter('date')(date, 'yyyy-MM-dd'), refreshData);
      var notification = {
        message: 'Deadline updated for ' + item.name + '.',
        pageToShow: 'Course',
        close: true,
        displayOrder: 2
      };
      notificationService.setNotification(notification);
      $timeout(function () {
        notificationService.removeNotification(notification);
      }, 5000);
    }

    $scope.bulkSetDeadline = function (event) {
      $scope.bulkDeadlineDate = event.date.getUTCFullYear() + '-' + (event.date.getUTCMonth() + 1) + '-' + event.date.getUTCDate();
      $scope.bulkDeadlineDateFormatted = $filter('date')(new Date((event.date.getUTCMonth() + 1) + '/' + event.date.getUTCDate() + '/' + event.date.getUTCFullYear()), 'dd-MMM-yyyy');
      $scope.$broadcast('traineesToSetDeadlineEvent', $scope.traineesToSetDeadlineCnt, $scope.bulkDeadlineDateFormatted);
      $('#setDeadlinePopupTrigger').click();
    };
    $scope.showAddYammerUsers = function () {
      return $scope.yammerEnabled && !mfConfig.useGroupRestrictions;
    };
  }

})();
